<template>
  <BasePlaceOrderButton :loading="loading" loadingText="提交中..." type="danger" text="提交" :disabled="isDisabled" :params="params" class="nextStep" :click="nextStep" />
</template>

<script>
import JSencrypt from '@/utils/rsa/jsencrypt';
import { Toast } from 'vant';
import { mapState, mapMutations, mapActions } from 'vuex';
import BasePlaceOrderButton from './BasePlaceOrderButton.vue';
import { buildXydAgreementLog, buildXydTypeList, flattenXydContracts } from '@/utils/xydNoTax';

export default {
  name: 'PlaceOrderButton',
  data() {
    return {
      isDisabled: true,
      loading: false,
      orderId: '',
    };
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  components: {
    BasePlaceOrderButton,
  },
  methods: {
    ...mapActions('publicPage', ['sendPicCode']),
    ...mapMutations('publicPage', ['updateState']),
    ...mapActions('commonForms', ['getModel']),
    ...mapMutations('commonForms', ['updateForm']),
    async nextStep() {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      const val = this.form.getState();
      if (this.publicPage.submitInfoAll.productId==='BW-BSD'&&val.iceContactPhone&&val.iceContactPhone2&&(val.iceContactPhone===val.iceContactPhone2)){
        return this.$toast.fail({
          message: '联系人手机号重复',
        });
      }
      if(this.publicPage.submitInfoAll.productId==='BW-BSD'&&((val.iceContactName&&val.borrowerName===val.iceContactName)||(val.iceContactName2&&val.borrowerName===val.iceContactName2))){
        return this.$toast.fail({
          message: '联系人姓名不能与借款人姓名一致',
        });
      }
      if (this.publicPage.submitInfoAll.productId==='BW-BSD'&&val.iceContactName&&val.iceContactName2&&(val.iceContactName===val.iceContactName2)){
        return this.$toast.fail({
          message: '联系人姓名重复',
        });
      }
      this.isDisabled = true;
      const encrypt = new JSencrypt();
      const resproductId = await this.$api.PublicPage.getNewProductId({
        productId: this.publicPage?.submitInfoAll?.productId,
        taxNo: this.publicPage?.submitInfoAll?.taxNo,
      });
      // this.publicPage?.submitInfoAll?.productId = resproductId.data
      encrypt.setPublicKey(
        'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ==',
      );
      console.log(this.publicPage.submitInfoAll)
      // eslint-disable-next-line no-underscore-dangle
      const contract = this.form._currentState.Contract || this.form._currentState.contract;
      const contractList = contract ? contract.props.list : [];
      const submitContractList = flattenXydContracts(contractList);
      const params = {
        ...this.publicPage.submitInfoAll,
        userType: this.publicPage.submitInfoAll.applyType,
        identity: this.publicPage.submitInfoAll.applyId,
        phone: this.publicPage.submitInfoAll.applyPhone,
        userName: this.publicPage.submitInfoAll.applyName,
        ...val,
        // 需要加密字段
        bankCard: encrypt.encrypt(val.bankCard) || '',
        creditBankCard: encrypt.encrypt(val.creditBankCard) || '',
        iceContactIdentity: encrypt.encrypt(val.iceContactIdentity) || '',
        iceContactPhone: encrypt.encrypt(val.iceContactPhone) || '',
        // 企业经营地址
        bizAddress: val?.bizAddress || '',
        bizAddressCode: val?.bizAddressList?.value || '',
        bizProvince: val?.bizAddressList?.name.split(' ')[0] || '',
        bizCity: val?.bizAddressList?.name?.split(' ')[1] || '',
        bizCounty: val?.bizAddressList?.name?.split(' ')[2] || '',
        // 居住地址
        borrowerAddressCode: val?.borrowerAddressList?.value || '',
        borrowerProvince: val?.borrowerAddressList?.name?.split(' ')[0] || '',
        borrowerCity: val?.borrowerAddressList?.name?.split(' ')[1] || '',
        borrowerCounty: val?.borrowerAddressList?.name?.split(' ')[2] || '',
        userType: this.publicPage.submitInfoAll?.borrowerType ? this.publicPage.submitInfoAll?.borrowerType?.toString() || '' : '',
        userTypeDesc: this.publicPage.submitInfoAll?.borrowerType === '1' ? '法人' : '股东',
        typeList: buildXydTypeList(resproductId.data, submitContractList, { excludeAuthorization: true }),
        productId: resproductId.data,
        foreignOrderId: this.$route.query.foreignOrderId,
        ...buildXydAgreementLog({
          productId: resproductId.data,
          formData: val,
          submitInfo: this.publicPage.submitInfoAll,
          contractList: submitContractList,
        }),
      };
      if (this.publicPage.isShowCorpName) {
        params.corpName = '';
        params.taxNo = '';
        params.corpId = '';
      }
      delete params.Button;
      delete params.Contract;
      delete params.bizAddressList;
      delete params.borrowerAddressList;
      if (params.legalIdentity === '411235765487654324') {
        delete params.legalName;
        delete params.legalIdentity;
        delete params.legalPhone;
      }
      this.loading = true;
      this.$api.PublicPage.saveOrderUnite(params).then((res) => {
        this.loading = false;
        this.isDisabled = false;
        if (res.success) {
          localStorage.setItem('orderId', res.data.orderId);
          this.updateForm({
            orderId: res.data.orderId,
          });
          this.orderId = res.data.orderId;
          // 判断是否需要采集数据到采集数据页面。
          this.judgeModelData(this.getModel);
        } else if (res.returnCode === '30010') {
            this.sendPicCode();
          }else {
          this.updateState({
            tabActive: 1,
          });
          this.updateForm({
            Isloading: false,
          });
          this.$toast.fail({
            message: res.returnMessage,
            forbidClick: true,
          });
        }
      }).catch((err) => {
        this.$toast.clear();
      });
    },
    async judgeModelData(callback) {
      const res = await this.$api.PublicPage.isDataAcquisition({
        orderId: this.orderId,
        productId: this.publicPage?.submitInfoAll?.productId,
      });
      // 根据type false true 判断是否跑模型还是去数据采集
      if (res.data.type) {
        const { data, returnCode, returnMessage } = await this.$api.PublicPage.jumpCurrPage({
          orderId: this.orderId,
        });
        console.log(data, '>>>>>>>>>');
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!data) {
          window.location.href = data;
        } else if (returnCode !== '200') {
          Toast(returnMessage);
        }
      } else {
        // 是否需要跳转选择核心企业
        const { success, data, returnMessage } = await this.$api.CommonForms.getCoreCorpPage({
          orderId: this.orderId,
        });
        if (success) {
          ['1', '2'].includes(data.type) ? window.location.href = data.url : callback(); // 调用跑模型接口
        } else {
          Toast(returnMessage);
        }
      }
    },
  },
  watch: {
    'form.passThrough': {
      handler() {
        this.isDisabled = this.form.passThrough || this.publicPage.haierIndex;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped></style>
